import React from 'react';
import { EyeOff, Clock, Award, Car } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const VIP_BG = 'https://static.prod-images.emergentagent.com/jobs/79680a12-b72c-4e4d-9800-308b06c8b20c/images/b7c732c8d8da828b450f38d1a55576326d6650069b72b9d34095efdca80d5b12.png';
const ICONS = [EyeOff, Clock, Award, Car];

const VipSection = () => {
  const { t } = useTranslation();
  const pillars = t('vip.pillars', { returnObjects: true });

  return (
    <section className="relative py-24 px-4 overflow-hidden"
      style={{ backgroundImage: `url(${VIP_BG})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      <div className="absolute inset-0 bg-black/75" />
      <div className="relative z-10 max-w-5xl mx-auto text-center">
        <p className="text-xs uppercase tracking-[0.2em] text-[#EAB308] font-semibold mb-3">{t('vip.label')}</p>
        <h2 className="text-3xl sm:text-4xl font-light text-white tracking-tight mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
          {t('vip.title')}
        </h2>
        <p className="text-white/65 text-base max-w-2xl mx-auto mb-12 leading-relaxed">{t('vip.subtitle')}</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {pillars.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <div key={p.title} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/8 hover:border-[#EAB308]/20 transition-all duration-300">
                <div className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-[#EAB308]/10 border border-[#EAB308]/20 mb-4">
                  <Icon size={20} className="text-[#EAB308]" />
                </div>
                <h3 className="text-white font-semibold text-base mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>{p.title}</h3>
                <p className="text-white/55 text-sm leading-relaxed">{p.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default VipSection;
